import { render } from "./MeetingEnded.vue?vue&type=template&id=c13813be&scoped=true"
import script from "./MeetingEnded.vue?vue&type=script&lang=js"
export * from "./MeetingEnded.vue?vue&type=script&lang=js"

import "./MeetingEnded.vue?vue&type=style&index=0&id=c13813be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c13813be"]])

export default __exports__